<template>
  <div class="pt-0 pt-md-16"></div>
  <div class="main-info ws-formated-text mt-n8 mt-md-16 px-2 px-sm-4">
    <div class="main-info__motto">
      <div class="nobr">Unlock the power of</div>
      <div class="nobr grad text-h2 mt-4 mt-sm-0 text-sm-h1 font-weight-bold">
        WireSock Secure Connect
      </div>
    </div>
    <div class="main-info__motto-subhead mt-4">
      Your secure gateway to seamless VPN connectivity
    </div>

    <v-row>
      <v-col class="text-center mt-4">
        <!--
        <video
          id="promo-video"
          src="/wssc-2.4/wssc-2.4_video.mp4"
          autoplay
          muted
          loop
          playsinline
          width="550"
          height="347"
          style="max-width: 100%; object-fit: contain; max-height: 347px; background: transparent"
        ></video>
        -->
        <iframe
          id="promo-iframe"
          src="/wssc-2.4/promo.html"
          title="WireSock Secure Connect overview"
          width="550"
          height="347"
          style="max-width: 100%; object-fit: contain; max-height: 347px;border: 0;"
          v-resize="onIframePromoResize"
          scrolling="no"
          @load="onIframePromoResize"
        >
        </iframe>
        <!--
        <img
          id="promo-img"
          src="/wssc-2-desktop1.webp?20250322"
          width="550"
          style="max-width: 100%; object-fit: contain; max-height: 347px;"
        />
        -->
      </v-col>
    </v-row>
    <div class="mt-8">
      <v-btn
        to="/wiresock-secure-connect/download"
        variant="flat"
        size="x-large"
        color="lime-accent-4"
        height="60"
        width="400"
        @click="scrollContentTop"
      >
        Download
      </v-btn>
      <div class="main-info__download-note text-body-2 mt-6">
        Windows x64, x86, ARM64 · Free for personal use ·
        <nuxt-link to="/wiresock-secure-connect/pro">PRO for business</nuxt-link>
      </div>
    </div>
    <div
      class="main-info__licensing mx-auto mt-8"
      :class="{ 'selected-block': selectedBlock === 'license' }"
      id="license-block"
    >
      <div
        id="license"
        class="font-weight-bold text-subtitle-1"
      >
        * License
      </div>
      <p class="font-italic mb-0">
        WireSock Secure Connect is free for personal (non-commercial), or
        educational (including non-profit organization) use. For commercial use,
        please
        <nuxt-link
          to="/wiresock-secure-connect/licensing"
        >
          visit the Licensing page
        </nuxt-link>
        or
        <nuxt-link to="/contacts">contact us</nuxt-link>
        for licensing options.
      </p>
    </div>
  </div>

  <div
    class="mx-auto mt-16 px-4"
    style="max-width: 100%; width: 1024px"
  >
    <div
      class="text-h2 mb-8"
      role="heading"
      id="what-is-wiresock-secure-connect"
    >
      What is WireSock Secure Connect?
    </div>
  </div>
  <div class="bg-light-green-lighten-2 ws-rag-content">
    <v-sheet
      color="#FFFFFFCC"
      class="main-info__motto-description mx-auto pt-8 pb-8 px-8"
      style="max-width: 1024px"
    >

      <div class="text-h5 mb-2">Enhanced WireGuard for Windows</div>

      <div class="text-body-1 mb-8">
        WireSock Secure Connect is a sophisticated WireGuard VPN client
        for Windows—available as both a command-line tool and a UI
        application—offering advanced capabilities not found in the
        official WireGuard client. It facilitates selective application
        tunneling and the exclusion of specific IP addresses. Designed for
        simplicity and ease of use, WireSock Secure Connect is a
        lightweight, transparent VPN solution that is

        <a
          href="#license"
          @click.prevent="scrollToLicense"
          class="text-primary"
        >free*</a>.
      </div>

      <div class="text-h5 mb-2">Superior Performance and Customizability</div>
      <div class="text-body-1 mb-4">
        Built on the solid foundations of
        <a
          href="https://www.ntkernel.com/windows-packet-filter/"
          target="_blank"
          class="text-primary"
        >Windows Packet Filter</a>
        and
        <a
          href="https://github.com/cloudflare/boringtun"
          target="_blank"
          class="text-primary"
        >BoringTun</a>,
        WireSock Secure Connect excels in performance, security, and
        scalability, catering to both regular users and demanding
        professionals.
      </div>

      <v-row v-if="false">
        <v-col
          class="main-info__block"
          cols="12"
          sm="6"
        >
          <v-card
            height="100%"
            variant="flat"
            color="#FFFFFFCC"
            border="surface-bright thin"
          >
            <v-card-title
              class="text-h6 text-md-h5 text-wrap"
            >
              Enhanced WireGuard for Windows
            </v-card-title
            >
            <v-card-text class="text-body-2">
              WireSock Secure Connect is a sophisticated WireGuard VPN client
              for Windows—available as both a command-line tool and a UI
              application—offering advanced capabilities not found in the
              official WireGuard client. It facilitates selective application
              tunneling and the exclusion of specific IP addresses. Designed for
              simplicity and ease of use, WireSock Secure Connect is a
              lightweight, transparent VPN solution that is
              <a
                href="#license"
                @click.prevent="scrollToLicense"
              >free*</a>.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          class="main-info__block"
          cols="12"
          sm="6"
        >
          <v-card
            variant="flat"
            height="100%"
            color="#FFFFFFCC"
          >
            <v-card-title
              class="text-h5 text-md-h5 text-wrap"
            >
              Superior Performance and Customizability
            </v-card-title>
            <v-card-text class="text-body-2">
              Built on the solid foundations of
              <a
                href="https://www.ntkernel.com/windows-packet-filter/"
                target="_blank"
              >Windows Packet Filter</a>
              and
              <a
                href="https://github.com/cloudflare/boringtun"
                target="_blank"
              >BoringTun</a>,
              WireSock Secure Connect excels in performance, security, and
              scalability, catering to both regular users and demanding
              professionals.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>

  <div
    class="mx-auto px-4 ws-rag-content"
    style="max-width: 1024px"
  >
    <div class="ws-formated-text pt-8">
      <div class="main-features__header text-h3 text-sm-h2 mt-8 mb-8">
        Principal Features:
      </div>

      <principal-features-v3/>
<!--      <principal-features-v2/>-->

      <div class="mt-8 mb-16 text-center">
        <v-btn
          to="/wiresock-secure-connect/download"
          variant="flat"
          size="x-large"
          color="indigo-accent-3"
          height="60"
          width="100%"
          max-width="400"
          @click="scrollContentTop"
        >
          Download
        </v-btn>
      </div>

      <!-- PRO Version Promo Block -->
      <wssc-pro-promo-block />

      <v-divider class="mt-8 mt-4"/>

      <div
        class="main-features__header text-h3 text-sm-h4 mt-8 mb-8"
        id="roadmap"
      >
        Roadmap
      </div>
      <p class="mb-6">Planned for future releases. No release dates are announced yet.</p>
      <div>

        <div class="text-h6">Per-App DSCP Marking</div>
        <p>Tags traffic with differentiated services <v-code tag="abbr" v-tooltip="'Differentiated Services Code Point'">(DSCP)</v-code> values on a per-application basis, letting you prioritize latency-sensitive apps (e.g., VoIP,
          gaming) over bulk transfers.</p>

        <div class="text-h6">Domain-Based Routing</div>
        <p>
          Route traffic to specific domains through the VPN matched via DNS, while leaving the rest of your connections on the regular network. Perfect for
          selectively tunneling services like banking or corporate portals.
        </p>
        <div class="text-h6 d-flex align-center flex-wrap ga-2">
          DNS Search Domains
          <v-chip
            size="small"
            color="primary"
            variant="tonal"
            to="/wiresock-secure-connect/download#beta"
          >
            Available in beta 3.7.1.1
          </v-chip>
        </div>
        <p>Define DNS search domains per profile (just like the official WireGuard client), so internal hostnames such as <v-code>printer.office</v-code> resolve automatically when you’re connected to the VPN.</p>

        <p class="font-italic mt-4">
          Need one of these for your use case?
          <nuxt-link to="/about/contacts" class="text-primary">Let us know</nuxt-link>
          — your feedback helps us prioritize development.</p>
      </div>

      <v-divider class="mt-8 mt-4"/>

      <div
        class="main-features__header text-h2 text-sm-h2 mt-10 mb-16"
        id="performance"
      >
        Performance
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <div class="main-performance format-paragraph">
            <div class="text-center font-weight-bold text-subtitle-2">
              Wireguard Software Upload and Download Speed Comparison:
            </div>
            <canvas
              id="performanceWireguardUploadDownload"
              height="200"
            >
              <v-img
                class="mb-4"
                src="/performance-wireguard-upload-download.png"
              />
            </canvas>

            <p>
              The following is a comprehensive comparison of throughput
              (upload/download) test results conducted with some of the most
              prominent Wireguard client implementations for Windows. These
              include the official WireguardNT and Wireguard-Go implementations,
              TunSafe, and the WireSock Secure Connect operating in transparent
              mode.
            </p>

            <p>
              The testing platform was an Intel® NUC DC3217IYE (Core i3-3217u),
              a machine that is over ten years old, running Windows 10 x64 on
              the client side. For each test, iperf3 was configured to utilize 4
              TCP sessions, corresponding to each virtual CPU. The most notable
              results were derived from a series of 10 consecutive tests, which
              are depicted in the initial chart.
            </p>
          </div>
        </v-col>
        <v-col>
          <p>
            The subsequent chart offers a comparative analysis of the
            performance between WireSock Secure Connect (in both Transparent and
            Virtual Adapter Modes) version 1.2.37 and WireguardNT version 0.5.3,
            operating over a 10Gbps network connection. For this evaluation, the
            client-side setup incorporated the Intel® Xeon® E-2378G Processor,
            complemented by the Broadcom P210tep NetXtreme-E Dual-port 10GBASE-T
            Ethernet PCIe Adapter.
          </p>
          <canvas
            id="performanceWireguard_2"
            height="200"
          >
            <v-img
              class="my-4"
              src="/performance-upload-download.png"
            />
          </canvas>

          <p>
            We conducted each test with iperf3, configured for 8 TCP sessions to
            produce the necessary traffic volume. The chart displays the best
            outcomes derived from a series of 10 consecutive tests.
          </p>
        </v-col>
      </v-row>
      <p>
        As illustrated in the above charts, the WireSock Secure Connect
        showcases notably higher download speeds compared to the official kernel
        mode implementation of Wireguard for Windows, and undoubtedly surpasses
        all other tested implementations.
      </p>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { scrollContentTop } from '~~/shared/services/menu/MenuService';
import PrincipalFeaturesV3 from '~/components/features/wssc-principal-features-v3.vue';
import PrincipalFeaturesV2 from '~/components/features/wssc-principal-features.vue';
import WsscProPromoBlock from '~/components/features/wssc-pro-promo-block.vue';
import { Chart } from 'chart.js/auto';

definePageMeta({
  alias: '/',
  // The home page is the main address of this page (owner decision 2026-10-22):
  // /wiresock-secure-connect points its canonical there and stays out of the sitemap.
  canonicalPath: '/',
});

// No "WireGuard" in the home page hero and meta (owner rule 2026-09-18).
useHead({
  meta: [
    {
      name: 'description',
      content:
        'VPN client for Windows with per-app split tunneling and DPI protection. Connect to your own VPN server or your provider\'s config. Free for personal use, PRO for business.',
    },
  ],
});

const scrollToLicense = () => {
  const licenseBlock = document.getElementById('license-block');
  selectedBlock.value = 'license';
  licenseBlock?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
const scrollToPerformance = () => {
  const performanceBlock = document.getElementById('performance');
  performanceBlock?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};

const selectedBlock = ref<'' | 'license'>('');
let performanceDownloadInstance_1: null | Chart = null;
let performanceDownloadInstance_2: null | Chart = null;

onMounted(() => {
  createPerformanceDownloadChart_1();
  createPerformanceDownloadChart_2();
  onIframePromoResize();
});

onBeforeUnmount(() => {
  if (performanceDownloadInstance_1) {
    performanceDownloadInstance_1.destroy();
  }
  if (performanceDownloadInstance_2) {
    performanceDownloadInstance_2.destroy();
  }
});

function createPerformanceDownloadChart_1() {
  if (performanceDownloadInstance_1) {
    performanceDownloadInstance_1.destroy();
  }

  const cnvs: null | HTMLCanvasElement = document.getElementById(
    'performanceWireguardUploadDownload',
  ) as HTMLCanvasElement;

  if (!cnvs) {
    return;
  }

  performanceDownloadInstance_1 = new Chart(cnvs, {
    type: 'bar',
    data: {
      labels: [
        [ 'WireSock', 'v1.0.46' ],
        [ 'WireGuard v0.5', ' for Windows', ' (WireguardNT)' ],
        [ 'WireGuard v0.4.1', ' for Windows', ' (WinTun)' ],
        'TunSafe V1.4',
      ],
      datasets: [
        {
          label: 'Upload Speed (Mbit/s)',
          backgroundColor: 'brown',
          data: [ 879, 892, 288, 435 ],
        },
        {
          label: 'Download Speed (Mbit/s)',
          backgroundColor: 'blue',
          data: [ 892, 719, 325, 284 ],
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: true,
          position: 'top',
          align: 'end',
          labels: {
            font: {
              size: 10,
            },
          },
        },

        // title: {
        //   display: true,
        //   text: 'Wireguard Software Upload and Download Speed Comparison',
        // },
      },
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: 'Speed (Mbit/s)',
          },
        },
        x: {
          ticks: {
            autoSkip: false,
            maxRotation: 120,
            minRotation: 0,
          },
        },
      },
    },
  });
}

function createPerformanceDownloadChart_2() {
  const ctx: null | HTMLCanvasElement = document.getElementById(
    'performanceWireguard_2',
  ) as HTMLCanvasElement;
  if (!ctx) return;
  if (performanceDownloadInstance_2) {
    performanceDownloadInstance_2.destroy();
  }
  performanceDownloadInstance_2 = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: [
        [ 'WireSock', 'Transparent' ],
        [ 'WireSock Virtual', 'VPN Configuration' ],
        [ 'WireGuard' ],
      ],
      datasets: [
        {
          label: 'Upload Speed (Gbps)',
          backgroundColor: 'blue',
          data: [ 5.27, 4.47, 5.24 ],
        },
        {
          label: 'Download Speed (Gbps)',
          backgroundColor: 'brown',
          data: [ 5.3, 3.63, 3.19 ],
        },
      ],
    },
    options: {
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: 'Speed (Gbps)',
          },
        },
        x: {
          ticks: {
            autoSkip: false,
            maxRotation: 90,
            minRotation: 0,
          },
        },
      },
    },
  });
}

// The promo scales itself to the iframe width; the page only keeps the 550x347 aspect ratio.
function onIframePromoResize() {
  const iframe = document.getElementById('promo-iframe') as HTMLIFrameElement;
  if (!iframe) {
    return;
  }
  iframe.style.height = `${ 347 * iframe.clientWidth / 550 }px`;
}
</script>

<style scoped>
.main-info-wrapper {
}

.main-info {
  font-size: 24px;
  text-align: center;
  padding: 50px 40px;
  min-height: 940px;
  /*background-image: url("/first-page-bg-pattern@0.5x.webp"), linear-gradient(-35deg, #56b5f5 20%, #6d34f5 70%);*/
  /*background-image: url("/first-page-bg-pattern-wb-opacity43.webp"), linear-gradient(-35deg, #56b5f5 20%, #6d34f5 70%);*/
  /* background-image: url("/first-page-bg-pattern-wb.webp"), linear-gradient(-35deg, #56b5f5 20%, #6d34f5 70%); */
  background-image: url('/first-page-bg-pattern-blue-3.webp'),
  linear-gradient(-15deg, #000000 40%, #0403E8 80%);
  /*background-color: #6d34f5;*/
  background-color: #010002;

  /* background-blend-mode: hard-light; */

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* .main-info::before {
  content: '';
  left: 0;
  top: 0;
  position: absolute;
  background-image: url('/first-page-bg-pattern.webp');
  background-position: center calc(50%);
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.4;

  width: 100%;
  height: 1500px;
  height: 100%;
  border: 2px solid red;
} */

.main-info__motto {
  color: white;
}

.main-info__motto .grad {
  background: linear-gradient(317deg, #ddadff 0%, #ffeaea 78%);
  background-clip: text;
  color: transparent;
  display: inline-block;
}

.main-info__motto-subhead {
  color: rgba(255, 255, 255, 0.9);
}

.main-info__download-note {
  color: rgba(255, 255, 255, 0.7);
}

.main-info__download-note a {
  color: rgba(255, 255, 255, 0.7);
}

.main-info__download-note a:hover {
  color: rgba(255, 255, 255, 0.9);
}

.main-info__motto-description {
  text-align: start;
  max-width: 1024px;
}

.main-info__block {
  /*
  //background-color: rgba(255, 255, 255, 0.8);
  //padding: 16px 24px;
  //border-radius: 5px;
   */
}

.main-info__download-button {
  display: inline-block;
  padding: 10px 20px;
  background: lightgreen;
  text-decoration: none;
  color: black;
  font-size: 32px;
  border-radius: 5px;
  min-width: 400px;
}

.main-info__licensing {
  margin-top: 40px;
  font-size: 12px;
  text-align: start;
  max-width: 950px;
  color: rgba(255, 255, 255, 0.44);
}

.main-info__licensing a {
  color: rgba(255, 255, 255, 0.5);
}

.main-info__licensing a:hover {
  color: rgba(255, 255, 255, 0.7);
}

.main-info__licensing #license {
  color: rgba(255, 255, 255, 0.24);
}

.main-info__licensing.selected-block a,
.main-info__licensing.selected-block #license {
  color: rgba(0, 0, 0, 0.5);
}

.main-features {
}

.main-performance {
}

.main-features__list {
  list-style-type: none;
}

.main-features__list-item {
  margin-bottom: 16px;
}

@keyframes borderColorAnimation {
  0% {
    border-color: transparent;
  }
  100% {
    border-color: #666;
  }
}

@keyframes backgroundColorAnimation {
  0% {
    background-color: transparent;
  }
  100% {
    background-color: #f0f0f0;
  }
}

.selected-block {
  background-color: #f0f0f0;
  padding: 16px 24px;
  border-radius: 10px;
  color: #000000;
  animation: backgroundColorAnimation 0.5s ease-in alternate;
}

canvas {
  max-width: 100%;
}
</style>
